import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from '../style/styles';
import StaffTranslationEditForm from '../forms/StaffTranslationEditForm';
import {
    updateStaffTranslation
} from '../thunks';

class StaffTranslationEdit extends Component {

    handleEditStaffTranslationSubmit = (formProps) => {
        this.props.updateStaffTranslation(
            formProps,
            this.props.staffId,
            this.props.staffTranslationId
        )
    }

    getSiteName = (options) => {
        let siteId = this.props.staffTranslation.site_id;

        let name = options.find(element => {
            return siteId === element.id ? siteId : ''
        });

        name = name ? name.display_name : '';
        return name;
    }

    render() {
        return (
            this.props.loading !== true &&
            <StaffTranslationEditForm
                staffMember={this.props.staffMember}
                siteName={this.getSiteName(this.props.sites)}
                handleFormSubmit={this.handleEditStaffTranslationSubmit.bind(this)}
                classes={this.props.classes}
                loading={this.props.loading}
                touched={this.props.touched}
                initialValues={this.props.initialValues}
            />
        )
    }
}

const mapStateToProps = (state, props) => ({
    initialValues: {
        staffId: state.staff.staffMember.id,
        translationId: state.staff.staffTranslation.id,
        title_id: state.staff.staffMember.title_id,
        name: state.staff.staffTranslation.name,
        firstname: state.staff.staffTranslation.firstname,
        description: state.staff.staffTranslation.description,
    },
    sites: state.sites.all,
    loading: state.layout.ajaxCallsInProgress > 0,
    touched: state.staff.touched,
});

export default connect(mapStateToProps, {
    updateStaffTranslation
})(withStyles(styles)(StaffTranslationEdit));


// WEBPACK FOOTER //
// ./src/containers/staff/translations/StaffTranslationEdit.jsx